import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad5cd454"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "printing-paper" }
const _hoisted_2 = { class: "row mb-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, null, -1))
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-center fw-bolder text-uppercase" }, " bảng kê chi tiết xuất ", -1))
const _hoisted_6 = {
  class: "text-center mb-1 fst-italic",
  style: {"font-size":"0.8rem"}
}
const _hoisted_7 = {
  class: "text-center mb-0",
  style: {"font-size":"0.9rem"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, null, -1))
const _hoisted_9 = {
  class: "text-center",
  style: {"font-size":"0.9rem"}
}
const _hoisted_10 = { class: "mx-2" }
const _hoisted_11 = { class: "mx-2" }
const _hoisted_12 = { class: "mx-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-end mb-0 fst-italic",
  style: {"font-size":"0.8rem"}
}, "ĐVT: đồng", -1))
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = {
  class: "d-flex justify-content-between mx-5 align-items-end",
  style: {"font-size":"0.8rem"}
}
const _hoisted_17 = { class: "flex flex-column justify-content-end align-items-center" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-center my-2 fst-italic",
  style: {"font-size":"0.8rem"}
}, " Ngày ..... tháng ..... năm ..... ", -1))

import { computed, PropType } from "vue";
import {
  IBangKeChiTietXuatResponseBase,
  IKhoResponseBase,
} from "@/core/interfaces/ApiResponses";
import ChiTietXuatTable from "../table-components/ChiTietXuatTable.vue";
import SignatureCol from "@/layout/_shared/SignatureCol.vue";
import PdfDocumentHeader from "@/components/shared/pdf-viewer/PdfDocumentHeader.vue";
import { useAuthPdfDonVi } from "@/core/hooks/use-auth-pdf-don-vi";


export default /*#__PURE__*/_defineComponent({
  __name: 'BangKeChiTietXuatPrintTemplate',
  props: {
  tenDonVi: { type: String, default: "" },
  tenDonViCha: { type: String, default: "" },
  from: { type: Date, default: () => new Date() },
  to: { type: Date, default: () => new Date() },
  items: {
    type: Array as PropType<IBangKeChiTietXuatResponseBase[]>,
    default: () => [],
  },
  kho: {
    type: Object as PropType<IKhoResponseBase | null>,
    default: null,
  },
  toaXeTen: { type: String, default: "" },
  toaXeMa: { type: String, default: "" },
  capSuaChuaTen: { type: String, default: "" },
},
  setup(__props) {

const props = __props;

const authDonVi = useAuthPdfDonVi();
const resolvedTenDonVi = computed(
  () => props.tenDonVi || authDonVi.tenDonVi.value
);
const resolvedTenDonViCha = computed(
  () => props.tenDonViCha || authDonVi.tenDonViCha.value
);


const dateDisplay = computed(() => {
  if (props.from.getMonth() === props.to.getMonth()) {
    return `${props.from.getMonth() + 1} năm ${props.from.getFullYear()}`;
  }

  return `Từ tháng ${
    props.from.getMonth() + 1
  } năm ${props.from.getFullYear()} đến tháng ${
    props.to.getMonth() + 1
  } năm ${props.to.getFullYear()}`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PdfDocumentHeader, {
      "ten-don-vi": resolvedTenDonVi.value,
      "ten-don-vi-cha": resolvedTenDonViCha.value
    }, null, 8, ["ten-don-vi", "ten-don-vi-cha"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("p", _hoisted_6, " Tháng " + _toDisplayString(dateDisplay.value), 1),
        _createElementVNode("p", _hoisted_7, " Xuất tại kho: " + _toDisplayString(__props.kho?.ten_kho), 1)
      ]),
      _hoisted_8
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("span", _hoisted_10, "Tên đối tượng: " + _toDisplayString(__props.toaXeTen), 1),
      _createElementVNode("span", _hoisted_11, "Mã đối tượng: " + _toDisplayString(__props.toaXeMa), 1),
      _createElementVNode("span", _hoisted_12, "Cấp sửa chữa: " + _toDisplayString(__props.capSuaChuaTen), 1)
    ]),
    _hoisted_13,
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(ChiTietXuatTable, {
          "is-print-modal": true,
          stripe: false,
          items: __props.items
        }, null, 8, ["items"])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", null, [
        _createVNode(SignatureCol, { "nguoi-ky": "Thủ kho" })
      ]),
      _createElementVNode("div", null, [
        _createVNode(SignatureCol, { "nguoi-ky": "Người giữ sổ" })
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createVNode(SignatureCol, { "nguoi-ky": "TP Tài Chính" })
      ])
    ])
  ]))
}
}

})